import React from 'react';
import { Form, FormGroup, FormLabel } from 'react-bootstrap';

interface ICreateAccountInput {
  onChange: (value: string) => void;
  onKeyDown?: (value: string) => boolean;
  label: string;
  name: string;
  placeholder?: string;
  autoComplete: string;
  inputType: string;
  selectOptions?: { value: string; text: string }[];
  fieldType: string;
  errors: string[];
  feedback?: string;
}

const CreateAccountInput = (props: ICreateAccountInput) => {
  const getField = (fieldType: string) => {
    switch (fieldType) {
      case 'input':
        return (
          <Form.Control
            as='input'
            id={props.label}
            name={props.name}
            type={props.fieldType}
            autoComplete={props.autoComplete}
            placeholder={props.placeholder}
            onChange={(e) => {
              e.preventDefault();
              const { value } = e.target;
              props.onChange(value);
            }}
            onKeyDown={(
              e: React.KeyboardEvent<HTMLInputElement | HTMLSelectElement>
            ) => {
              if (props.onKeyDown) {
                if (!props.onKeyDown(e.key)) {
                  e.preventDefault();
                }
              }
            }}
            isInvalid={props.errors.includes(props.name)}
          />
        );
      case 'select':
        return (
          <Form.Control
            as='select'
            id={props.label}
            name={props.name}
            type={props.fieldType}
            onChange={(e) => {
              e.preventDefault();
              const { value } = e.target;
              props.onChange(value);
            }}
            isInvalid={props.errors.includes(props.name)}
          >
            <option value=''>--</option>
            {props.selectOptions &&
              props.selectOptions.map((option, index) => {
                return (
                  <option key={index} value={option.value}>
                    {option.text}
                  </option>
                );
              })}
          </Form.Control>
        );
    }
  };

  return (
    <FormGroup>
      <FormLabel htmlFor={props.name}>{props.label}</FormLabel>
      {getField(props.inputType)}
      <Form.Control.Feedback type='invalid'>
        {props.feedback || 'This field is required.'}
      </Form.Control.Feedback>
    </FormGroup>
  );
};

export default CreateAccountInput;
